import {
  createPlugin,
  createRoutableExtension,
  createComponentExtension,
  createApiFactory,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { saSreChatApiRef } from './api/SaSreChatApi';
import { SaSreChatClient } from './api/SaSreChatClient';

/**
 * SA_SRE Chat Plugin
 *
 * Provides:
 * - ChatFab: Floating action button (always visible)
 * - ChatPanel: Slide-up compact chat panel
 * - ChatFullPage: Full-screen 3-pane chat layout
 * - ChatWidget: Combined FAB + Panel + FullPage (mount once at root)
 * - ContextBridge: Syncs portal navigation to chat context
 * - SaSreChatApi: API client for superagent-sre via Backstage proxy
 */
export const saSreChatPlugin = createPlugin({
  id: 'sa-sre-chat',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: saSreChatApiRef,
      deps: { fetchApi: fetchApiRef },
      factory: ({ fetchApi }) => new SaSreChatClient({ fetchApi }),
    }),
  ],
});

/**
 * Full-page chat view (routable extension for /sre-chat route)
 */
export const SaSreChatPage = saSreChatPlugin.provide(
  createRoutableExtension({
    name: 'SaSreChatPage',
    component: () =>
      import('./components/ChatFullPage/ChatFullPageRoute').then(m => m.ChatFullPageRoute),
    mountPoint: rootRouteRef,
  }),
);

/**
 * Chat widget (FAB + Panel + FullPage) — mount at app root level.
 * This is non-routable so it persists across page navigations.
 */
export const SaSreChatWidget = saSreChatPlugin.provide(
  createComponentExtension({
    name: 'SaSreChatWidget',
    component: {
      lazy: () =>
        import('./SaSreChatWidget').then(m => m.SaSreChatWidget),
    },
  }),
);
